/**
 * @file organization actions
 * @author atom-yang
 */

export const SET_MODIFY_ORG_DETAIL = 'SET_MODIFY_ORG_DETAIL';
export const setCurrentOrg = (org) => ({ type: SET_MODIFY_ORG_DETAIL, payload: org });
